/**
 * OVERRIDE DefaultBody.jsx
 * REASON: Adding Button.
 */

import SliderBody from '../../../../components/Blocks/Slider/DefaultBody';

export default SliderBody;
